import moment from 'moment'

class DateTimeHelper {
  public static secondsToDisplayTime(theSeconds): string {
    const minutes = Math.floor(theSeconds / 60)
    const seconds = (theSeconds % 60).toFixed(0)
    const formattedMinutes = String(minutes).padStart(2, '0')
    const formattedSeconds = String(seconds).padStart(2, '0')
    return `${formattedMinutes}:${formattedSeconds}`
  }

  public static secondsToMinutes(theSeconds): string {
    const minutes = Math.floor(theSeconds / 60)

    return `${minutes}`
  }

  public static fromNow(datetime): string {
    return moment(datetime).fromNow()
  }

  public static stringToDateTime(datetime): string {
    return moment(datetime).format('MM/DD HH:mm')
  }

  public static stringToDateTimeYear(datetime): string {
    return moment(datetime).format('YYYY-MM-DD')
  }
}

export default DateTimeHelper
